module.exports = __webpack_public_path__ + "static/img/comshow_one.346e30f2.jpg";